/** 2 Marker Sizes: Small Size & Large Size */

import { IconNameV2 } from 'common/icon/iconV2.js';
import { StatusRating } from 'utilities/status/status-rating.js';

export enum MarkerTypeName {
  Pill = 'pill',
  Label = 'label',
  FilterPill = 'filter',
}

export type BaseV2Content = {
  markerClass?: string;
  pillClass?: string;
  /** Should cluster marker using buildClusterGroup */
  cluster?: boolean;
};

export type PillV2Content = BaseV2Content & {
  hasPoint?: boolean;
  icon?: IconNameV2;
  /** @deprecated use tags instead not deprecated in FilterPoint */
  theme?: string;
  /** @deprecated use meta instead status too opinionated */
  status?: StatusRating;
  /** Additional data to support theme */
  meta?: string;
  text?: string;
};

export type MarkerPillPoint = {
  type?: MarkerTypeName.Pill; // default option if not provided
  /** Pill summary icon / short text */
  view?: PillV2Content;
  // For time series data
  timeSeriesUrl?: string;
  timeSeriesView?: Record<string, PillV2Content>;
};

export type MarkerPillFilterPoint = {
  type: MarkerTypeName.FilterPill;
  /** Default view used in all views */
  view?: PillV2Content;
  /** views merged with view  */
  views?: Record<
    string,
    PillV2Content & {
      /** theme used here to override parent tags */
      theme?: string;
    }
  >;

  // For time series data
  timeSeriesUrl?: string;
  timeSeriesView?: Record<string, Record<string, PillV2Content>>;
};

export type MarkerPillLabel = {
  type: MarkerTypeName.Label;
  /** Pill summary icon / short text */
  view?: BaseV2Content;
};

export type IMarkerV2Core<T extends MarkerPillPoint | MarkerPillLabel | MarkerPillFilterPoint | undefined = undefined> =
  T extends undefined ? MarkerPillPoint | MarkerPillLabel | MarkerPillFilterPoint : T;
